import { render, staticRenderFns } from "./CitationsList.vue?vue&type=template&id=5139c1ea&scoped=true"
import script from "./CitationsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CitationsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CitationsList.vue?vue&type=style&index=0&id=5139c1ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139c1ea",
  null
  
)

export default component.exports